export default __webpack_public_path__ + "static/media/prize_round.a7cdc201.webm";